<script setup lang="ts">
import UserAccountInfo from '@/components/UserAccountInfo.vue';
</script>

<template>
    <div class="ovr-grid">
        <div class="left">
            <h2 class="ktg-title-02 mb-2rem">{{ $t('settings') }}</h2>
            <ktg-tabs appearance="secondary" class="mt-2rem mb-2rem">
                <RouterLink
                    :to="{ name: 'useraccount-settings-profile', params: {} }"
                    custom
                    v-slot="{ isExactActive, navigate }"
                >
                    <ktg-tab :active="isExactActive || null" @activate="navigate">{{ $t('profile') }}</ktg-tab>
                </RouterLink>
                <RouterLink
                    :to="{ name: 'useraccount-settings-security', params: {} }"
                    custom
                    v-slot="{ isExactActive, navigate }"
                >
                    <ktg-tab :active="isExactActive || null" @activate="navigate">{{ $t('security') }}</ktg-tab>
                </RouterLink>
            </ktg-tabs>
            <RouterView></RouterView>
        </div>
        <div class="right">
            <UserAccountInfo/>
        </div>
    </div>
</template>

<style scoped>
.right {
    margin-top: 13px;
    height: fit-content;
    position: sticky;
    top: 8.5rem;
    width: 560px;
    flex-basis: 560px;
}
.left {
  flex-grow: 1 !important;
}
.ovr-grid {
    display: flex;
    gap: 5rem;
    margin-top: 5rem;
    margin-bottom: 5rem;
}
</style>
